import { render } from "./TableStandard.vue?vue&type=template&id=5de6e19a"
import script from "./TableStandard.vue?vue&type=script&lang=js"
export * from "./TableStandard.vue?vue&type=script&lang=js"
script.render = render

export default script